import type { QuestionnaireResultResponse, QuestionnaireRevisionContext } from '@gcv/shared';

type RevisionWithDueDate = QuestionnaireRevisionContext & { due_date?: string };

export const getEffectiveDueDate = (result: QuestionnaireResultResponse): string => {
  const history = (result.revision_history ?? []) as RevisionWithDueDate[];
  if (history.length === 0) {
    return result.due_schedule.due_date;
  }

  const latest = [...history].sort((a, b) => a.requested_on.localeCompare(b.requested_on))[
    history.length - 1
  ];

  if (latest.due_date && latest.due_date.length > 0) {
    return latest.due_date;
  }
  return result.due_schedule.due_date;
};
